import { combineReducers } from 'redux';
import commandHistoryStorage from "./commandHistoryStorage.js";
import fileStorage from "./fileStorage.js";
import workspaceStorage from "./workspaceStorage.js";
export default combineReducers({
  commandHistoryStorage,
  fileStorage,
  workspaceStorage
});
//# sourceMappingURL=index.js.map